import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('components.credential_sharing_nag_banner')

// Intentional deviation from palette — matches the amber "action needed"
// treatment used by GrantedRewardExpirationBanner.
const AMBER_BANNER_BG = '#FFF8E1'

type Props = {
  // Re-open the nag modal. Persists as an entry point even after the merchant
  // has dismissed the modal for the day.
  onReview: () => void
}

const CredentialSharingNagBanner = ({ onReview }: Props) => {
  const [css] = useStyletron()

  return (
    <div
      role="status"
      aria-label={t('banner_aria_label')}
      data-testid="credential-sharing-banner"
      // `below-navbar` provides the navbar clearance for this in-flow banner
      // (mirrors GrantedRewardExpirationBanner). The fixed `<header>` is out of
      // flow, so without this the banner renders at y=0 behind the navbar. It is
      // only in the DOM when the banner actually renders (the guard returns null
      // otherwise), so it never strips page clearance via `.below-navbar ~ main`.
      // When both banners show, `.below-navbar ~ .below-navbar` (index.scss)
      // collapses the second banner's offset so they stack without a gap.
      className={
        'below-navbar ' +
        css({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '16px 20px',
          backgroundColor: AMBER_BANNER_BG,
          boxSizing: 'border-box',
          width: '100%',
        })
      }
    >
      <span
        className={css({
          color: palette.grey90,
          fontSize: '14px',
          lineHeight: '20px',
        })}
      >
        {t('message')}
      </span>
      <button
        type="button"
        onClick={onReview}
        className={css({
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          color: palette.belizeHole,
          textDecoration: 'underline',
          fontWeight: 600,
          font: 'inherit',
          marginLeft: '8px',
          ':focus-visible': {
            outline: `2px solid ${palette.belizeHole}`,
            outlineOffset: '2px',
            borderRadius: '2px',
          },
        })}
      >
        {t('cta')}
      </button>
    </div>
  )
}

export default CredentialSharingNagBanner
